import { getMissions } from "../skylineApi"
import { bindData, byId } from "../utils"
import * as adminFeed from "../adminFeed"
import * as feather from "feather-icons"

const root = byId("missionsTemplate")
const missionEntry = byId("missionEntry")
let missionListView = root.content.cloneNode(true).firstElementChild
const missionsE = missionListView.querySelector(".mission-list")
missionListView.style.display = "none"

adminFeed.register("mission", (ev) => {
	if (!ev.mission) {
		console.error("Mission event without a mission", ev)
		return
	}

	switch (ev.action) {
	case "CREATE":
		const before = Array.from(missionsE.children).find( e => e.dataset.missionId < ev.mission.id )
		addEntry(ev.mission, before)
		break
	case "UPDATE":
		const e = missionsE.querySelector(`[data-mission-id='${ev.mission.id}']`)
		if (!e) {
			console.error("Got an update to an unknown mission", ev)
			return
		}
		bindData(ev.mission, e)
		break
	case "DELETE":
		const rem = missionsE.querySelector(`[data-mission-id='${ev.mission.id}']`)
		if (rem) missionsE.removeChild(rem)
	}
})

function addEntry(mission, before) {
	const newEntry = missionEntry.content.firstElementChild.cloneNode(true)
	newEntry.addEventListener("click", () => {
		app.router.navigate("/missions/" + mission.id)
	}, true)
	bindData(mission, newEntry)
	newEntry.dataset.missionId = mission.id
	if (before) {
		missionsE.insertBefore(newEntry, before)
	} else {
		missionsE.appendChild(newEntry)
	}
	feather.replace()
}

export default function index(app) {
	app.router.on('/missions', (match) => {
		console.log("Drawing all missions route")
		const missions = Object.values(getMissions())
		missions.sort((a,b) => b.id - a.id)
		if (missionsE.querySelectorAll(".mission-entry").length < missions.length) {
			console.log("Redrawing the mission list")
			for (const m of missions) {
				addEntry(m)				
			}
		}
		missionListView.style.display = "block"
		app.setContent(missionListView)
	})
}